import { useEffect, useState } from "react";

import { useLayout } from "@/../_metronic/layout/core";

import { FaEye } from "react-icons/fa";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { Role } from "@/@types/app/Role";
import { getAllProfiles } from "@/services/app/profileService";

import { ModalPerfilAccess } from "@/components/ModalPerfilAccess";
import { useCurrentAccount } from "@/hooks/useCurrentAccount";

export function AccessProfiles() {
	const { module } = useCurrentAccount();
	const { setTitle } = useLayout();
	const [isloading, setIsLoading] = useState(false);
	const [selectedRole, setSelectedRole] = useState<Role>({} as Role);
	const [roles, setRoles] = useState<Role[]>([]);

	async function handleFetchProfiles() {
		setIsLoading(true);
		setRoles(await getAllProfiles(module));
		setIsLoading(false);
	}

	useEffect(() => {
		setTitle("GESTÃO DE PERFIL");
		handleFetchProfiles();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [showModalPerfilAccess, setShowModalPerfilAccess] = useState(false);
	const handleShowModalPerfilAcess = () => {
		setShowModalPerfilAccess(true);
	};
	const handleCloseModalPerfilAccess = () => setShowModalPerfilAccess(false);

	return (
		<div className="h-100 p-2">
			<ModalPerfilAccess
				show={showModalPerfilAccess}
				onHide={handleCloseModalPerfilAccess}
				role={selectedRole}
			/>
			<Card className="h-100">
				<Card.Body>
					<table
						id="table-profile"
						className=" table-responsive table align-middle table-row-dashed fs-7 fw-bold dataTable bg-white no-footer"
					>
						<thead>
							<tr className="text-center text-muted">
								<th>
									<strong>Slug</strong>
								</th>
								<th>
									<strong>Perfil</strong>
								</th>
								<th>
									<strong>Descrição</strong>
								</th>
								<th>Ações</th>
							</tr>
						</thead>
						<tbody className="table-tbody">
							{roles?.map((role, index) => (
								<tr key={index} className="border-bottom-1 border-dark">
									<td>{role.slug}</td>
									<td>{role.name}</td>
									<td>{role.description}</td>
									<td>
										<div className="d-flex justify-content-end me-2 gap-1">
											<Button
												className="btn-primary"
												onClick={() => {
													setSelectedRole(role);
													handleShowModalPerfilAcess();
												}}
												disabled={isloading}
											>
												<FaEye />
											</Button>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</Card.Body>
			</Card>
		</div>
	);
}
